<div [formGroup]="form">
  <div class="password-strength-rules">
    <p>
      The password must have a minimum of {{ passwordStrengthRules?.minimumLength }} characters, contain at least
      {{ passwordStrengthRules?.minimumSpecialCharacters }} special characters, a minimum of
      {{ passwordStrengthRules?.minimumNumericCharacters }} numeric characters, and at least
      {{ passwordStrengthRules?.minimumUpperCaseCharacters }} uppercase character(s). The password can't contain more
      than {{ passwordStrengthRules?.maxConsecutiveCharacters }} identical characters in a row.
    </p>
  </div>
  <mat-form-field class="password-field">
    <input
      [type]="hidePassword ? 'password' : 'text'"
      matInput
      formControlName="newPassword"
      placeholder="Password"
      aria-label="password"
      required
      autocomplete="new-password"
      />
      <mat-icon class="peek-icon" matSuffix (click)="hidePassword = !hidePassword">{{
        hidePassword ? 'visibility_off' : 'visibility'
      }}</mat-icon>
      @if (form.hasError('required', 'newPassword')) {
        <mat-error> Please enter a new password </mat-error>
      }
      @if (
        form.hasError('minlength', 'newPassword') ||
        form.hasError('specialcharacters', 'newPassword') ||
        form.hasError('uppercasecharacters', 'newPassword') ||
        form.hasError('numericcharacters', 'newPassword') ||
        form.hasError('consecutive', 'newPassword')
        ) {
        <mat-error
          >
          Password doesn't meet the requirements
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <input
        [type]="hideConfirmPassword ? 'password' : 'text'"
        matInput
        formControlName="confirmNewPassword"
        placeholder="Confirm Password"
        aria-label="confirm Ppssword"
        autocomplete="new-password"
        required
        />
        <mat-icon class="peek-icon" matSuffix (click)="hideConfirmPassword = !hideConfirmPassword">{{
          hideConfirmPassword ? 'visibility_off' : 'visibility'
        }}</mat-icon>
        @if (form.hasError('match', 'confirmNewPassword') || form.hasError('required', 'confirmNewPassword')) {
          <mat-error
            >
            Passwords do not match
          </mat-error>
        }
      </mat-form-field>
    </div>
